module.exports = __webpack_public_path__ + "img/forge.8507bc5c.png";